export enum InsafDeliveryStatusCode {
	Pending = "PENDING",
	Sending = "SENDING",
	RetryScheduled = "RETRY_SCHEDULED",
	Delivered = "DELIVERED",
	Failed = "FAILED",
	Rejected = "REJECTED",
	Cancelled = "CANCELLED",
	NotSent = "NOT_SENT",
}
